<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-lg">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="" style="width:100%; padding: 20px">
                      <iframe
                        title="Share a Success Story"
                        src="https://www.jotform.com/form/200414758515049"
                        width="100%"
                        height="625"
                        frameborder="0"
                        style="border:none;"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: [],
  components: {},
  data() {
    return {
      isModalShown: true,
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
  },
};
</script>


// WEBPACK FOOTER //
// ShareStoryForm.vue?2a9d668f